import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import OutlinedCard from './OutlinedCard';
import ClientProvider from './client';
export default createDemo(import.meta.url, OutlinedCard, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/cards/demos/outlined/OutlinedCard.tsx",
    "fileName": "OutlinedCard.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Card from '@mui/material/Card';\nimport CardActions from '@mui/material/CardActions';\nimport CardContent from '@mui/material/CardContent';\nimport Button from '@mui/material/Button';\nimport Typography from '@mui/material/Typography';\n\nconst bull = (\n  <Box\n    component=\"span\"\n    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}\n  >\n    •\n  </Box>\n);\n\nconst card = (\n  <React.Fragment>\n    <CardContent>\n      <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>\n        Word of the Day\n      </Typography>\n      <Typography variant=\"h5\" component=\"div\">\n        be{bull}nev{bull}o{bull}lent\n      </Typography>\n      <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>adjective</Typography>\n      <Typography variant=\"body2\">\n        well meaning and kindly.\n        <br />\n        {'\"a benevolent smile\"'}\n      </Typography>\n    </CardContent>\n    <CardActions>\n      <Button size=\"small\">Learn More</Button>\n    </CardActions>\n  </React.Fragment>\n);\n\nexport default function OutlinedCard() {\n  return (\n    <Box sx={{ minWidth: 275 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Card variant=\"outlined\">{card}</Card>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 46,
        "focusedLines": 1,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Card from '@mui/material/Card';\nimport CardActions from '@mui/material/CardActions';\nimport CardContent from '@mui/material/CardContent';\nimport Button from '@mui/material/Button';\nimport Typography from '@mui/material/Typography';\n\nconst bull = (\n  <Box\n    component=\"span\"\n    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}\n  >\n    •\n  </Box>\n);\n\nconst card = (\n  <React.Fragment>\n    <CardContent>\n      <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>\n        Word of the Day\n      </Typography>\n      <Typography variant=\"h5\" component=\"div\">\n        be{bull}nev{bull}o{bull}lent\n      </Typography>\n      <Typography sx={{ color: 'text.secondary', mb: 1.5 }}>adjective</Typography>\n      <Typography variant=\"body2\">\n        well meaning and kindly.\n        <br />\n        {'\"a benevolent smile\"'}\n      </Typography>\n    </CardContent>\n    <CardActions>\n      <Button size=\"small\">Learn More</Button>\n    </CardActions>\n  </React.Fragment>\n);\n\nexport default function OutlinedCard() {\n  return (\n    <Box sx={{ minWidth: 275 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Card variant=\"outlined\">{card}</Card>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Card"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "outlined",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "card"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              "</",
              [
                "span",
                "pl-c1 di-jsx",
                "Card"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 46,
    "focusedLines": 1,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Card",
      "@mui/material/CardActions",
      "@mui/material/CardContent",
      "@mui/material/Button",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
